export const userNameToUserEmail = (
    usersName: string,
    nameToEmail: Record<string, string>,
): string => {
    return nameToEmail?.[usersName] || usersName;
};
